// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_kd-1";
export var quotedThread = "_kd-0";